<template>
    <div id="media-manager">
        <div class="hidden">
            <form method='post' action='' enctype="multipart/form-data">
                <input type="file" ref="filesInput" @change="onFilesAdded" name="files[]" accept="image/*" multiple>
            </form>
        </div>

        <div class="text-right">
            <button class="btn btn-primary" @click="onAddMediaClick"><i class="fas fa-plus"></i> Add Photos</button>
            <br />
        </div>

        <div class="media-items" ref="mediaItems" :style="medaItemsStyle">
            <media-item v-for="mediaItem in mediaItems" :key="mediaItem.id" :media-item="mediaItem" @delete="onDelete" ></media-item>
        </div>
        <div v-if="mediaItems.length == 0">
            No items
        </div>
    </div>  
</template>

<script>
import { Uploader } from "./uploader";
import { default as MediaManagerApi } from "../../api/media-manager-api";
import { ContenderMedia } from "./contender-media";
import MediaItemComponent from './MediaItem.vue';
import {Swappable, Plugins} from '@shopify/draggable';

const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif"];
let uploaderClient = null

export default {
    name: 'media-manager',

    components:{
        'media-item' : MediaItemComponent
    },

    props: {
        propertyId : {
            type:Number,
            required: true
        },

        contenderId : {
            type:Number,
            required: true
        }
    },

    data() {
        return {
            mediaItems : [],
            idToken : null,
            s3Region : null,
            s3Bucket: null
        }
    },  

    async mounted(){
        const getContextResult = await MediaManagerApi.getContext(this.contenderId);
        var ctx = getContextResult.data;

        this.idToken = ctx.idToken;
        this.mediaItems = ctx.media;

        uploaderClient = new Uploader(ctx.s3Bucket, ctx.s3Region);

        const swappable = new Swappable(document.querySelectorAll('.media-items'), {
            draggable: '.media-item',
            delay: 250
        });

        swappable.on('drag:start', function(){
            console.log('drag start');
        });
    },

    computed : {
        medaItemsStyle(){
            if(this.mediaItems.length == 0){
                return {
                    "display": "none"
                };
            }else{
                return {};
            }
        }
    },

    methods : {
        uploadFiles(){
            
        },

        async onFilesAdded(){
            // Read selected files
            var totalfiles = this.$refs.filesInput.files.length;

            console.log(totalfiles);

            // We don't want to keep warning the user multiple times
            // if they uploaded a bunch of bad extension media. 
            // Just show them the warning once.
            let displayedWarning = false;

            let uploadPromises = [];
            
            // Upload each file
            for (var index = 0; index < totalfiles; index++) {
                var file = this.$refs.filesInput.files[index];

                // Check that the file name ext is allowed
                const fileNameExt = "." + file.name.split('.').pop();

                // If the extension type isn't allowed, display the warning
                if(ALLOWED_EXTENSIONS.indexOf(fileNameExt.toLowerCase()) == -1){
                    const allowedExtensionsDesc = ALLOWED_EXTENSIONS.join(', ');

                    if(!displayedWarning){
                        displayedWarning = true;
                        VoterFly.UI.showModal(
                            "Image type not allowed", 
                            `We do not allow images with a <strong>${fileNameExt.toLowerCase()}</strong> extension. Please upload files with one of the following extensions: ${allowedExtensionsDesc}.`
                            );
                    }

                    // Skip this file
                    continue;
                }


                // Create a model to display in the UI that will eventually be
                // replaced with the server-side model.
                let contenderMedia = new ContenderMedia();
                contenderMedia.contenderId = this.contenderId;
                contenderMedia.originalFileName = file.name;
                contenderMedia.status = "UPLOADING";
                
                const allOrdinals = this.mediaItems.map(mi => mi.ordinal);

                let maxOrdinal = Math.max(0, ...allOrdinals);

                contenderMedia.ordinal = maxOrdinal + 1;
                contenderMedia.previewImageUrl = URL.createObjectURL(file);

                this.mediaItems.push(contenderMedia);

                // Fetch this back from the array so we get a proxied object
                contenderMedia = this.mediaItems[this.mediaItems.length-1];

                const upload = await uploaderClient.uploadFile(file, `${this.propertyId}/${this.contenderId}/`, null);

                contenderMedia.upload = upload;

                const uploadPromise = upload.done();
                
                uploadPromise.then(async (uploadResult) => {
                    const fileName = uploadResult.Key.split('/').pop();
                    contenderMedia.fileName = fileName;
                    contenderMedia.status = "UPLOADED";

                    await this.postContenderMedia(contenderMedia);

                    contenderMedia.status = null;
                });

                uploadPromises.push(uploadPromise);
            }


            await Promise.all(uploadPromises);
        },

        async postContenderMedia(contenderMedia){
            const apiResult = await MediaManagerApi.postContenderMedia(contenderMedia);
            Object.assign(contenderMedia, apiResult.data);
        },

        async onDelete(arg){
            const id = arg.id;
            var mediaItem = this.mediaItems.find(mediaItem => mediaItem.id == id);
            
            this.mediaItems.splice(this.mediaItems.indexOf(mediaItem), 1);

            if(mediaItem.status == 'UPLOADING'){
                mediaItem.upload.abort();
            }else{
                await MediaManagerApi.deleteContenderMedia(this.contenderId, id);
            }
        },

        onAddMediaClick(){
            this.$refs.filesInput.click();
        }
    }
}
</script>

<style lang="scss">
    $media-item-gap:3px;

    .media-items{
        display:grid;
        grid-auto-rows: max-content;
        grid-template-columns: repeat(auto-fit, 125px);
        justify-items: center;
        column-gap:$media-item-gap;
        row-gap:$media-item-gap;
        position:relative;

        .draggable-mirror{
            opacity: .8;
            box-shadow: 0px 2px 3px rgba(0, 0, 0, .05);
        }
    }
</style>
